<template>
  <h3
    class="text-lg font-medium leading-loose text-background-fg/70"
  >
    <slot />
  </h3>
</template>
